import { render, staticRenderFns } from "./Link.vue?vue&type=template&id=54e5f693"
import script from "./Link.vue?vue&type=script&lang=js"
export * from "./Link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.32_cache-loader@4.1.0_webpack@4.47.0__css-load_a8bd752108d19ce5ee9fa3466e44f1d3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports